<template>
  <div :style="{ height: height }">
    <el-scrollbar>
      <div style="height: 100%">
        <div style="width: 100%; margin: auto; height: 100%">
          <!--          <vue-pdf-embed-->
          <!--            v-if="state.url"-->
          <!--            ref="pdfRef"-->
          <!--            :source="state.url"-->
          <!--            @rendered="rendered"-->
          <!--          />-->
          <iframe
            v-if="state.url"
            :src="state.url"
            style="width: 100%; border: none; height: 100%"
          />
          <el-empty v-else description="暂无报告" />
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script setup>
// import VuePdfEmbed from "vue-pdf-embed";
const platformConfig = computed(() => {
  const config = sessionStorage.getItem("platform-config");
  return JSON.parse(config || "{}");
});
onMounted(() => {
  watch(
    () => model.value,
    () => {
      if (model.value.url) {
        state.value.url = `${model.value.report_ip ? model.value.report_ip + platformConfig.value.BaseURLMinioContainer : ""}${model.value.url}`;
      } else {
        state.value.url = "";
      }
    }
  );
});
defineProps({
  height: {
    type: String,
    default: "100%"
  }
});
const model = defineModel({
  default: {
    url: "./help.pdf"
  }
});
const state = ref({
  url: ""
});

function rendered() {}
</script>
<style scoped lang="scss"></style>
